<template lang="pug">
//- .new-order-done-popup.d-flex.justify-content-center.align-items-center
  //- .backdrop
.popup-card.card.text-center.p-5.h-100
  .my-auto
    .text-center.mb-5: img.img-128(src="@/assets/icons/bill.png")
    .px-5
      p.h4 แก้ไขรายการขายเสร็จสมบูรณ์
      .pt-4
        button.btn.btn-secondary.mt-4(style="min-width: 240px;" @click="$router.go(-1)")
          | ตกลง
</template>

<script>
export default {
};
</script>

<style lang="scss">
.new-order-done-popup {
  position: fixed; top: 0; right: 0; left: 0; bottom: 0;
  padding: 24px;
  z-index: 20;
  .backdrop {
    position: absolute; top: 0; right: 0; left: 0; bottom: 0;
  }
  .popup-card {
    width: 100%;
    min-width: 480px;
    max-width: 640px;
  }
}
</style>
